/*       */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { RouterMatchPropTypeBuilder } from 'app/utils/propTypes/common';

import Grafana from './Grafana';
import PageNotAllowed from '../ErrorPages/PageNotAllowed';
import { setDocumentTitle } from 'store/actions/app/appActions';
import { modulesAndPageTitles } from 'app/config/typesConfig';

class GrafanaRoute extends Component {
    static propTypes = {
        match: RouterMatchPropTypeBuilder({ id: PropTypes.string }),
        profile: PropTypes.object,
    };

    componentDidMount() {
        this.props.setDocumentTitle(modulesAndPageTitles.analytics.grafana);
    }

    render() {
        const { match } = this.props;
        const { isAdmin, permissions } = this.props.profile;
        const permissionsSet = new Set(permissions);
        const canView = isAdmin || permissionsSet.has('analytics.grafana');
        if (!canView) {
            return <PageNotAllowed title="Grafana" />;
        }
        return (
            <Switch>
                <Route path={`${match.url}`} exact component={Grafana} />
            </Switch>
        );
    }
}

export default connect(
    state => ({
        profile: state.user.profile,
    }),
    {
        setDocumentTitle,
    }
)(GrafanaRoute);
